<div *ngIf="!isAnomalies else dataForm">
<div bsModal
     #staticModal="bs-modal"
     class="modal fade"
     tabindex="-1"
     role="dialog"
     aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" aria-label="Close" (click)="close()">
          <span aria-hidden="true">X</span>
        </button>
        <storever-header-modal [title]="'ORDER_LIST_MANUALLY_CLOSE_ORDER'" [icon]="'fal fa-home'"></storever-header-modal>
      </div>
      <span *ngIf="selectedItemUuid">
          <storever-header-subtitle [datas]="[
          {icon: 'fa-cart-plus', title: 'GENERIC_ORDER_LABEL', name: (order$|async)?.displayName},
          {icon: 'fa-users', title: 'GENERIC_CLIENT', name: (order$|async)?.client?.name},
          {icon: 'fa-map-marker-alt', title: 'GENERIC_SITE', name: (order$|async)?.site?.displayName}]
          "></storever-header-subtitle>
      </span>
      <div class="modal-body">
        <div class="portlet-body">
          <form [formGroup]="form" class="pickup">
            <storever-element-group
              [icon]="'fal fa-hdd'"
              [title]="'none'"
              [config]="formConfig.config"
              [form]="form">
            </storever-element-group>
          </form>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" [disabled]="form.invalid" (click)="send()"> {{'SEND' | translate:locale.language}} </button>
        <!--        <button type="button" class="btn btn-default" (click)="close()">{{'CANCEL' | translate:locale.language}}</button>-->
      </div>
    </div>
  </div>
</div>
</div>
<!--this template is used when we call this modal via data table-->
<ng-template #dataForm >
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" aria-label="Close" (click)="closeBSF()">
              <span aria-hidden="true">X</span>
            </button>
            <h4 class="modal-title" translate>ORDER_LIST_MANUALLY_DELIVERY_DATE
              <span *ngIf="selectedItem?.length" translate>({{selectedItem?.length}} selected subscriptions)</span></h4>
          </div>
          <span *ngIf="selectedOneItem ; else multiItems">
          <storever-header-subtitle [datas]="[
           {icon: 'fa-users', title: 'GENERIC_CLIENT', name: selectedOneItem.clientName},
           {icon: 'fa-map-marker-alt', title: 'GENERIC_SITE', name: selectedOneItem?.name},
           {icon: 'fal fa-box', title: 'GENERIC_PRODUCT', name: selectedOneItem.productName}]"></storever-header-subtitle>
      </span>
          <ng-template #multiItems >
            <div [ngClass]="selectedItem?.length > 6 ? 'scroll' : null">
          <span *ngFor="let item of selectedItem" >
          <storever-header-subtitle [datas]="[
           {icon: 'fa-users', title: 'GENERIC_CLIENT', name: item.clientName},
           {icon: 'fa-map-marker-alt', title: 'GENERIC_SITE', name: item?.name},
           {icon: 'fal fa-box', title: 'GENERIC_PRODUCT', name: item.productName}]"></storever-header-subtitle>
      </span>
            </div>
          </ng-template >
          <div class="modal-body">
            <div class="portlet-body">
              <form [formGroup]="form" class="pickup">
                <storever-element-group
                  [icon]="'fal fa-hdd'"
                  [title]="'none'"
                  [config]="formConfig.config"
                  [form]="form">
                </storever-element-group>
              </form>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary" [disabled]="form.invalid" (click)="send()"> {{'SEND' | translate:locale.language}} </button>
            <button type="button" class="btn btn-default" (click)="closeBSF()">{{'CANCEL' | translate:locale.language}}</button>
          </div>
        </div>
</ng-template>
